import React, { useState, useEffect } from "react";
import AddNewPitanje from "../Pitanje/AddNewPitanje";
import { Form, Input, Button, DatePicker, Select, Modal } from "antd";
import dayjs from "dayjs";
import { addAnketa } from "../../services/anketa.service";
import { addPitanje } from "../../services/pitanje.service";
import { addPonudjeniOdgovor } from "../../services/ponudjeniOdgovor.service";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../Anketa/AddNewAnketa.css";
import Pitanje from "../Pitanje/Pitanje";
import EditPitanjeBeforeSave from "../Pitanje/EditPitanjeBeforeSave";
import SaglasnostService from "../../services/saglasnost.service";
import { useAuth } from "../../components/AuthContext";

const { TextArea } = Input;

function AddNewAnketa({ onSubmit }) {
  const [naziv, setNaziv] = useState("");
  const [opis, setOpis] = useState("");
  const [statusAnkete, setStatus] = useState("AKTIVNA");
  const { username } = useAuth();
  const [datumVazenja, setDatumVazenja] = useState(null);
  const [tip, setTip] = useState("JAVNA");
  const [pitanja, setPitanja] = useState([]);
  const [counter, setCounter] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [editPitanjaPozicije, setEditPitanjaPozicije] = useState([]);
  const [saglasnosti, setSaglasnosti] = useState([]);
  const [saglasnost, setSaglasnost] = useState(1);
  const [confirmIndex, setConfirmIndex] = useState(null);
  useEffect(() => {
    const fetchSaglasnosti = async () => {
      try {
        const response = await SaglasnostService.getAll();
        setSaglasnosti(response.data);
      } catch (error) {
      }
    };

    fetchSaglasnosti();
  }, []);

  const handleEditClick = (pozicija) => {
    setEditPitanjaPozicije((prevState) => {
      if (prevState.includes(pozicija)) {
        return prevState.filter((p) => p !== pozicija);
      } else {
        return [...prevState, pozicija];
      }
    });
  };

  const handleAddPitanje = (novoPitanje) => {
    const pitanjeSaOdgovorima = {
      ...novoPitanje,
      ponudjeniOdgovori: novoPitanje.ponudjeniOdgovori.map((odgovor) => ({
        ...odgovor, //,
       
      })),
    };
    setCounter((prevCounter) => prevCounter + 1);

    setPitanja([...pitanja, pitanjeSaOdgovorima]);
  };

  const handleUpdatePitanje = (uredjenoPitanje) => {
    const pitanjeSaOdgovorima = {
      ...uredjenoPitanje,
      ponudjeniOdgovori: uredjenoPitanje.ponudjeniOdgovori.map(
        (odgovor, index) =>
          typeof odgovor === "string"
            ? { id: null, tekstOdgovora: odgovor, pozicija: index + 1 } 
            : { ...odgovor, pozicija: index + 1 } 
      ),
    };  
    setPitanja((prevPitanja) =>
      prevPitanja.map((pitanje) =>
        pitanje.pozicija === pitanjeSaOdgovorima.pozicija
          ? pitanjeSaOdgovorima
          : pitanje
      )
    );
    setEditPitanjaPozicije((prevState) =>
      prevState.filter((pozicija) => pozicija !== uredjenoPitanje.pozicija)
    );
  };

  const handleDeletePitanje = (index) => {
    setPitanja(pitanja.filter((_, i) => i !== index));
  };

  const isFormValid = () => {
  return (
    naziv.trim() !== "" &&
    statusAnkete.trim() !== "" &&
    tip.trim() !== "" &&
    saglasnost !== null
  );
};

  const handleSubmit = async () => {
    const novaAnketa = {
      naziv,
      opis,
      statusAnkete,
     datumKreiranja: dayjs().format("YYYY-MM-DDTHH:mm:ss"),
     datumVazenja: datumVazenja ? datumVazenja.format("YYYY-MM-DDTHH:mm:ss") : null,
      tip,
      korisnikKorisnickoIme: username,
      saglasnostId: saglasnost,
    };

    try {
      const response = await addAnketa(novaAnketa);
      const kreiranaAnketa = response.data;
      for (const pitanje of pitanja) {
        const pitanjeRequest = {
          tekstPitanja: pitanje.tekstPitanja,
          objasnjenje: pitanje.objasnjenje,
          tip: pitanje.tip,
          obavezno: pitanje.obavezno,
          pozicija: pitanje.pozicija,
          anketaId: kreiranaAnketa.id,
        };

        const pitanjeResponse = await addPitanje(pitanjeRequest);
        const kreiranoPitanje = pitanjeResponse.data;

        pitanje.ponudjeniOdgovori.forEach(async (odgovor, index) => {
          const odgovorRequest = {
            tekstOdgovora: odgovor.tekstOdgovora,
            pozicija: index + 1,
            pitanjeId: kreiranoPitanje.id,
          };

          try {
            await addPonudjeniOdgovor(odgovorRequest);
          } catch (error) {
          }
        });
      }

      if (onSubmit) {
        onSubmit(kreiranaAnketa);
      }
    } catch (error) {
    }
  };

  const handleModalOk = () => {
    if (!isFormValid()) {
    Modal.error({
      title: "Popunite sva polja",
      content: "Molimo vas da popunite sva obavezna polja prije dodavanja ankete.",
    });
    return;
  }
    setModalVisible(false);
    handleSubmit();
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const azurirajPozicije = (novaPitanja) => {
    return novaPitanja.map((pitanje, index) => ({
      ...pitanje,
      pozicija: index + 1, 
    }));
  };

  const handleMoveUp = (index) => {
    if (index === 0) return;
    const novaPitanja = [...pitanja];
    [novaPitanja[index - 1], novaPitanja[index]] = [
      novaPitanja[index],
      novaPitanja[index - 1],
    ];

    setPitanja(azurirajPozicije(novaPitanja));
  };

  const handleMoveDown = (index) => {
    if (index === pitanja.length - 1) return;
    const novaPitanja = [...pitanja];
    [novaPitanja[index], novaPitanja[index + 1]] = [
      novaPitanja[index + 1],
      novaPitanja[index],
    ];

    setPitanja(azurirajPozicije(novaPitanja));
  };
  return (
    <div className="container add-new-anketa-container">
      <div className="add-new-anketa-card">
        <h1 className="add-new-anketa-title">Nova anketa</h1>
        <Form
          layout="horizontal"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          className="poll-form"
        >
          <Form.Item label="Naziv" required>
            <Input
              className="input-field add-new-anketa-input"
              value={naziv}
              onChange={(e) => setNaziv(e.target.value)}
              placeholder="Unesite naziv ankete"
            />
          </Form.Item>

          <Form.Item label="Opis">
            <TextArea
              className="textarea-field add-new-anketa-input"
              value={opis}
              onChange={(e) => setOpis(e.target.value)}
              placeholder="Unesite opis ankete"
            />
          </Form.Item>

          <Form.Item label="Datum važenja">
            <DatePicker
              className="input-field add-new-anketa-input"
              value={datumVazenja ? dayjs(datumVazenja) : null}
              onChange={(date) => setDatumVazenja(date)}
              showTime
              placeholder="Izaberite datum"
            />
          </Form.Item>

          <Form.Item label="Saglasnost">
            <Select
              value={saglasnost}
              onChange={setSaglasnost}
              className="select-field add-new-anketa-select"
            >
              {saglasnosti.map((saglasnost) => (
                <Select.Option key={saglasnost.id} value={saglasnost.id}>
                  {saglasnost.naziv}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Status ankete">
            <Select
              value={statusAnkete}
              onChange={setStatus}
              className="select-field add-new-anketa-select"
            >
              <Select.Option value="AKTIVNA">Aktivna</Select.Option>
              <Select.Option value="NEAKTIVNA">Neaktivna</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label="Tip ankete">
            <Select
              value={tip}
              onChange={setTip}
              className="select-field add-new-anketa-select"
            >
              <Select.Option value="JAVNA">Javna</Select.Option>
              <Select.Option value="ZASTICENA">Zaštićena</Select.Option>
            </Select>
          </Form.Item>
        </Form>
        
        {pitanja.map((pitanje, index) => (
          <div key={pitanje.pozicija} className="question-item">
            {editPitanjaPozicije.includes(pitanje.pozicija) ? (
              <EditPitanjeBeforeSave
                pitanje={pitanje}
                onSubmit={handleUpdatePitanje}
              />
            ) : (
              <>
                <div
                  style={{
                    marginLeft: "20px",
                    marginRight: "30px",
                    marginTop: "20px",
                    paddingTop: "10px",
                  }}
                >
                  <h4 className="tekst-pitanja">
                    <span className="obavezno-zvezdica">
                      {pitanje.obavezno ? "*" : "\u00A0"}
                    </span>
                    <span className="tekst-broj">{pitanje.pozicija}.</span>
                    <span className="tekst-tekst">
                      {pitanje.tekstPitanja} (
                      {{
                        TEKSTUALNO: "Tekstualno",
                        DA_NE: "Da/ne",
                        JEDAN_IZBOR: "Jedan izbor",
                        VISESTRUKI_IZBOR: "Višestruki izbor",
                      }[pitanje.tip] || pitanje.tip}
                      )
                    </span>
                  </h4>

                  {pitanje.objasnjenje && (
                    <h5 className="pitanje-objasnjenje">
                      {pitanje.objasnjenje}
                    </h5>
                  )}

                  {pitanje.ponudjeniOdgovori.length > 0 && (
                    <ul className="answer-list">
                      {pitanje.ponudjeniOdgovori.map((odgovor, i) => (
                        <li key={i}>{odgovor.tekstOdgovora}</li>
                      ))}
                    </ul>
                  )}
                </div>
              </>
            )}

            <div className="button-container">
              <button
                onClick={() => handleMoveUp(index)}
                className="move-btn move-up"
              >
                ↑
              </button>
              <button
                onClick={() => handleMoveDown(index)}
                className="move-btn move-down"
              >
                ↓
              </button>
              <button
                onClick={() => handleEditClick(pitanje.pozicija)}
                className="edit-button"
              >
                {editPitanjaPozicije.includes(pitanje.pozicija)
                  ? "Cancel Edit"
                  : "Edit"}
              </button>
              <button
                className="delete-button"
                onClick={() =>
                  setConfirmIndex(confirmIndex === index ? null : index)
                }
              >
                ✖
              </button>

              {confirmIndex === index && (
                <div className="confirm-popup">
                  <p className="confirm-text">Obrisati pitanje?</p>
                  <div className="confirm-buttons">
                    <button
                      className="confirm-btn confirm-yes"
                      onClick={() => {
                        handleDeletePitanje(index);
                        setConfirmIndex(null);
                      }}
                    >
                      Da
                    </button>
                    <button
                      className="confirm-btn confirm-no"
                      onClick={() => setConfirmIndex(null)}
                    >
                      Ne
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
        <AddNewPitanje onSubmit={handleAddPitanje} counter={counter} />
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            type="primary"
            size="large"
            onClick={() => setModalVisible(true)} 
             disabled={!isFormValid()}
            className="button-primary"
          >
            Sačuvaj anketu
          </Button>
        </div>
      </div>
      

      <Modal
        className="custom-anketa-modal"
        title="Da li želite da kreirate anketu?"
        visible={modalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okText="OK"
        cancelText="Otkaži"
        centered
        width="80%"
        maxWidth="80%"
        bodyStyle={{ padding: "30px", overflowY: "auto" }}
      >
        <div className="modal-card">
          <h2 className="modal-title">{naziv}</h2>
          <h4 className="modal-subtitle">{opis}</h4>
          <p>
            <strong>Tip ankete:</strong> {tip}
          </p>
          <p>
            <strong>Status:</strong> {statusAnkete}
          </p>
          <p>
            <strong>Datum važenja:</strong>{" "}
            {datumVazenja
              ? datumVazenja.format("YYYY-MM-DD HH:mm")
              : "Nema datuma"}
          </p>
          <h3 className="modal-question-title">Pitanja:</h3>
          <div className="modal-question-list">
            {pitanja
              .sort((a, b) => a.pozicija - b.pozicija)
              .map((p) => (
                <Pitanje key={p.id} pitanje={p} />
              ))}
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default AddNewAnketa;
